import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Founder from './components/Founder';
import CoreValues from './components/CoreValues';
import Programs from './components/Programs';
import Corporate from './components/Corporate';
import LeThanhThanh from './components/LeThanhThanh';
import Differentiators from './components/Differentiators';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <About />
      <Founder />
      <LeThanhThanh />
      <CoreValues />
      <Programs />
      <Corporate />
      <Differentiators />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
